import { GeometryTypes } from "@/helpers/enums"
import { PathOptions } from "leaflet"
import DynamicRightSlotData from "./dynamicrighslotdata"

/** Kohteiden geometria data */
export interface GeometryData {
    type: string; // koordinaattien tyyppi (polygon, point jne)
    coordinates: any;
    options: PathOptions | null; // alueiden tyylimääritykset
    markerOptions: any; // pistekohteiden tyyli määritykset
    handleOnClick: boolean; // reagoiko layer hiiren klikkaukseen (rightslot datan esitys / highlight)
    /** // sallitut geometria tyypit, jos null/tyhä kaikki sallittu. Jos listalla nii piirretään jos ei löydy listalta niin ei piirretä kartalle.
     * Käytetyt arvot: GeometryTypes enumista: Point,MultiPoint,LineString,MultiLineString,Polygon, MultiPolygon,GeometryCollection
     */
    allowedGeometryTypes: GeometryTypes[] | null;
}
/** Rajapinnasta tuodun datan yleismodel, johon sijoitetaan rajapinnasta tuotu data kartalle piirtoa varten jne */
export default class ApiDataModel {
    constructor(
        id: string,
        /** muunnetaanko geometria oikeaan muotoon, oletus true */
        convertGeometry: boolean,
        /** Pelkkä geometriadata */
        geometryData: GeometryData | null = null,
        /** Kohteen tiedot, vapaassa muodossa tuodun datan muokaisesti */
        featureData: any,
        /** righslotissa näytettävä data */
        rightSlotData: DynamicRightSlotData | null = null,
        /** markerData, jos näytetään vain merkkejä/pisteitä tällöin muut tiedot voivat olla tyhjiä -> poistuu käytöstä */
        markerData :any,
        /** reagoiko layer hiiren klikkaukseen (rightslot datan esitys / highlight) */
        handleOnClick: boolean = true,
        /** // sallitut geometria tyypit, jos null/tyhjä kaikki sallittu. Jos listalla nii piirretään jos ei löydy listalta niin ei piirretä kartalle.
        * Käytetyt arvot: Point,MultiPoint,LineString,MultiLineString,Polygon, MultiPolygon,GeometryCollection
        */
        allowedGeometryTypes: GeometryTypes[] | null = null) {
            this.id = id
            this.convertGeometry = convertGeometry
            this.geometryData = geometryData
            this.featureData = featureData
            this.rightSlotData = rightSlotData
            this.markerData = markerData
            this.handleOnClick = handleOnClick
            this.allowedGeometryTypes = allowedGeometryTypes
        }

    id: string
    convertGeometry: boolean = true
    geometryData: GeometryData | null
    featureData: any
    rightSlotData: DynamicRightSlotData | null
    markerData: any
    handleOnClick: boolean
    allowedGeometryTypes: GeometryTypes[] | null
    layer: any

    static createEmpty(): ApiDataModel {
        return new ApiDataModel("0", true, null, null, null, null)
    }
}
